<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
            <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../assets/images/pop/cgsp/cgsp1.png" class="steps step1" v-if="status==1">
            <img src="../../assets/images/pop/cgsp/cgsp2.jpg" class="steps step2" v-if="status==2">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'审批采购订单'}]"/>
        <div class="h-content">
            <el-form :model="zy" label-position="right" ref="zy" :inline="true"
                     class="demo-ruleForm h-formbLine h-formbLine1">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan4">
                                            <el-form-item label="采购订单号" class="h-elformWrap-2">
                                                <el-input v-model="zy.code" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="供应商名称" class="h-elformWrap-2" prop="suserCode">
                                                <el-input v-model="zy.suserName" readonly></el-input>
                                                <!--<el-select v-model="zy.suserCode" placeholder="请选择"-->
                                                <!--filterable-->
                                                <!--@change="changeSup(zy.suserCode)">-->
                                                <!--<el-option v-for="(item) in options2"-->
                                                <!--:key="item.value"-->
                                                <!--:label="item.label"-->
                                                <!--:value="item.value" >-->
                                                <!--</el-option>-->
                                                <!--</el-select>-->
                                            </el-form-item>
                                            <el-form-item label="期望到货时间" class="h-elformWrap-2" prop="expectDate">
                                                <div class="block">
                                                    <el-input v-model="zy.expectDate" readonly></el-input>
                                                    <!--<el-date-picker-->
                                                    <!--v-model="zy.expectDate"-->
                                                    <!--type="datetime"-->
                                                    <!--placeholder="&#45;&#45;选择&#45;&#45;"-->
                                                    <!--:clearable=false>-->
                                                    <!--</el-date-picker>-->
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="创建人" class="h-elformWrap-2">
                                                <el-input v-model="zy.cuname" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                                <el-input v-model="zy.cdate" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWap-2">
                                                <el-input v-model="zy.notes" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="项目合同" v-if="zy.hhxmCode != null && zy.hhxmCode !=''" class="h-elformWrap-2">
                                                <el-input v-model="zy.hhxmCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="质保开始时间" v-if="zy.hhxmCode != null && zy.hhxmCode !=''" class="h-elformWrap-2">
                                                <el-input v-model="zy.endTimeHhxm" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="质保结束时间" v-if="zy.hhxmCode != null && zy.hhxmCode !=''" class="h-elformWrap-2">
                                                <el-input v-model="zy.endTimeHhxm" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>产品信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan4">
                                            <!--                                            <el-form-item label="产品大类" class="h-elformWrap-2">-->
                                            <!--                                                <el-input  v-model="zy.productCateName" readonly></el-input>-->
                                            <!--                                            </el-form-item>-->
                                            <!--                                            <el-form-item label="产品型号" class="h-elformWrap-2">-->
                                            <!--                                                <el-input  v-model="zy.productDes" readonly></el-input>-->
                                            <!--                                            </el-form-item>-->
                                            <!--                                            <el-form-item label="产品单价" class="h-elformWrap-2">-->
                                            <!--                                                <el-input  v-model="zy.unitPrice" readonly></el-input>-->
                                            <!--                                            </el-form-item>-->
                                            <!--                                            <el-form-item label="产品数量" class="h-elformWrap-2">-->
                                            <!--                                                <el-input  v-model="zy.count" readonly></el-input>-->
                                            <!--                                            </el-form-item>-->
                                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                                <el-input v-model="zy.totalPrice" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan4">
                                            <el-form-item label="物流类型" class="h-elformWrap-2" prop="waybillType">
                                                <!--<el-select v-model="zy.waybillType" placeholder="请选择" readonly>-->
                                                <!--<el-option v-for="(item) in options1"-->
                                                <!--:key="item.code"-->
                                                <!--:label="item.name"-->
                                                <!--:value="item.code">-->
                                                <!--</el-option>-->
                                                <!--</el-select>-->
                                                <span v-if="zy.waybillType == '3' ">
                                                    <el-input value="库发" readonly></el-input>
                                                </span>
                                                <span v-else>
                                                    <el-input v-model="zy.waybillTypeName" readonly></el-input>
                                                </span>
                                            </el-form-item>
                                            <el-form-item label="接收人" class="h-elformWrap-2">
                                                <el-input v-model="zy.receiver" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="接收人手机号" class="h-elformWrap-2">
                                                <el-input v-model="zy.receverPhone" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2">
                                                <el-input v-model="zy.receiveUnit" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2">
                                                <el-input v-model="zy.detailAddress" style="width: 400px;" readonly></el-input>
                                            </el-form-item>

                                        </div>
                                    </div>
                                </div>

                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>附件信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan4">
                                            <el-form-item label="附件" class="h-elformWrap-2" prop="fileId" >
                                                <brupload
                                                        :refid="zy.fileId"
                                                        reftype="采购订单附件"
                                                        :uploadflag="false"
                                                        :delflag="false"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>

                                        </div>
                                    </div>
                                </div>

                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>型号信息</h1>
                                    </div>
                                    <div class="yxtable ljjtable">
                                        <el-table
                                                ref="multipleTable"
                                                :data="tableData3"
                                                style="width: 100%"
												border
                                                tooltip-effect="dark"
                                                @selection-change="handleSelectionChange"
                                        >
                                            <el-table-column
                                                    type="selection"
                                                    fixed
                                                    width="50"
                                                    disabled='true'
                                                    :selectable='checkboxT'>
                                            </el-table-column>
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productCate"
                                                    label="产品大类"
                                                    min-width="150">
                                                <template slot-scope="scope">
                                                    {{scope.row.productCateName}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productNo"
                                                    label="产品型号"
                                                    min-width="250">
                                                <template slot-scope="scope">
                                                    {{scope.row.productDes}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="oemDesc"
                                                    label="规格型号"
                                                    min-width="250">
                                                <template slot-scope="scope">
                                                    {{scope.row.oemDesc}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="suserCode"
                                                    label="供应商名称"
                                                    min-width="300"
                                            >
                                                <template slot-scope="scope">
                                                    {{scope.row.suserName}}
                                                </template>

                                            </el-table-column>
                                            <el-table-column
                                                    prop="unitPrice"
                                                    label="产品单价"
                                                    min-width="150">
                                                <template slot-scope="scope">
                                                    {{scope.row.unitPrice}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="currency"
                                                    label="币种"
                                                    width="110"
                                                    :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    {{scope.row.currency | dictname('YLCurrency')}}
                                                </template>
                                            </el-table-column>
                                             <el-table-column
                                                    prop="sid"
                                                    label="特价版本"
                                                    min-width="150">
                                                <template slot-scope="scope">
                                                    {{scope.row.sid}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="count"
                                                    label="产品数量"
                                                    min-width="150">
                                                <template slot-scope="scope">
                                                    {{scope.row.count}}
                                                </template>
                                            </el-table-column>
                                          <el-table-column
                                              prop="unitPrice"
                                              label="库存量"
                                              min-width="150">
                                            <template slot-scope="scope">
                                              {{scope.row.sapCount}}
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                              prop="unitPrice"
                                              label="在途量"
                                              min-width="150">
                                            <template slot-scope="scope">
                                              {{scope.row.roadCount}}
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                              prop="unitPrice"
                                              label="占用量"
                                              min-width="150">
                                            <template slot-scope="scope">
                                              {{scope.row.orderCount}}
                                            </template>
                                          </el-table-column>
                                            <el-table-column
                                                    prop="yremark"
                                                    label="备注"
                                                    min-width="150">
                                                <template slot-scope="scope">
                                                    {{scope.row.yremark}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="status"
                                                    label="审批状态"
                                                    min-width="150">
                                                <template slot-scope="scope">
                                                    <dictname category="caigou_zhuangtai" :v="scope.row.status" v-model="scope.row.status" style="width:3.1rem"/>
                                                </template>
                                            </el-table-column>

                                        </el-table>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

                <div class="h-row h-mrt1">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>审核信息</h1>
                                    </div>
                                    <div class="h-pieceCon2 ">
                                        <div class="h-formLine dingdan4" style="position: relative;">
                                            <el-form-item label="审批意见" class="h-elformWrap-2 newBox" :required="true"
                                                          style="width: 100%!important;">
                                                <el-input v-model="zy.des" placeholder="请输入"></el-input>
                                            </el-form-item>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
            <div class="apprButton">
                <el-button v-if="taskstatus==1" class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                <el-button v-if="taskstatus==0" class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                <el-button v-if="taskstatus==0" class="h-btn h-bBtn h-bgred" @click="refuse">驳回</el-button>
                <el-button v-if="taskstatus==0" class="h-btn h-bBtn h-bggreen" @click="pass">通过</el-button>
				<el-button class="h-btn h-bBtn" @click="viewpress">
				    审批跟踪
				</el-button>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import util from "../../utils/util"

    export default {
        data() {
            return {

                shenpixianshi:[],

                tableData3: [],

                xuanzhonglist: [],


                checked: true,
                showOrhide: false,
                status: 1,
                toshow: 'orderCgLdApprove1',
                //带线表单
                value: false,
                showhistory: false,
                ywid: this.$route.query.ywid,
                instid: this.$route.query.instid,
                options2: [],
                zy: {
                    des: '',
                },
                taskstatus: this.$route.query.taskstatus
                // rules: {
                //     suserCode: [
                //         {required: true, message: '请选择供应商名称', trigger: 'blur'}
                //     ],
                //     expectDate: [
                //         {required: true, message: '请选择期货时间', trigger: 'change'},
                //     ],
                //     waybillType: [
                //         {required: true, message: '请选择物流类型', trigger: 'change'}
                //     ],
                // }
            }
        },

        mounted() {

            console.log(this.$route.query,'aaaqquuuyy')

            if (this.ywid != null) {
                //查看订单详情
                ss.orderCgService.caigouselectById(this.ywid).then(rd => {

                    if (rd.obj) {

                        //加载自己信息
                        this.jiazaiobjxinxi(rd.obj);

                        //若兄弟信息存在
                        if (rd.obj.orderCgList) {

                            //加载兄弟信息
                            this.jiazaixiongdi(rd.obj.orderCgList);

                        }

                    }


                })
            }
        },

        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            //限制只有待审批的才能选，其他选不了
            checkboxT(row, index) {
                if (row.status == 1) {
                    return 1
                } else {
                    return 0
                }
            },

            //选中条方法
            handleSelectionChange(lists) {

                console.log(lists, 'lists')

                //选中的
                this.xuanzhonglist = lists;

            },

            //增加行
            adds() {

                var list = {

                    productCateName: '',
                    productDes: '',
                    productCate: '',
                    productNo: '',
                    productOptions: [],
                    suserCode: '',
                    suserName: '',
                    options2: [],
                    unitPrice: '',
                    count: '',
                    proId: '',

                }


                this.tableData3.push(list)

            },

            //加载当前自己的原始信息
            jiazaiobjxinxi(q) {

                //初始化默认数据
                this.zy = q

                if (this.zy.des) {
                    this.zy.des = ''
                }


            },


            //加载兄弟信息
            jiazaixiongdi(q) {


                var orderCg = {

                    instidlist:[],
                    taskId:this.$route.query.taskid,

                };

                for (var s in q) {

                    this.adds();

                    orderCg.instidlist.push(q[s].instid)

                }


                console.log(orderCg,'入参')

                ss.orderCgService.shuaixuanInstid(orderCg).then(rd => {

                    console.log(rd,'可以显示的，需要审批的')

                    //过滤存在
                    if(JSON.stringify(rd.obj) != '{}' && this.$route.query.taskid){

                        this.shenpixianshi = rd.obj;

                        var qq = [];

                        for(var c in q){

                            for(var d in rd.obj){

                                if(q[c].instid==rd.obj[d]){

                                    qq.push(q[c])

                                }

                            }

                        }

                        this.tableData3 = [];

                        for(var c in qq){

                            this.tableData3[c] = qq[c];

                        }
                      console.log(10081,this.tableData3)

                    }else{

                        for(var c in q){

                            this.tableData3[c] = q[c];

                        }
                      console.log(10082,this.tableData3)

                    }

                })



            },


            cancel() {
                this.$router.push("/personal/dealCenter");
            },

            refuse() {

                if (this.xuanzhonglist.length > 0) {

                    this.newrefuse();

                } else {

                    this.$msg.msge("请先选择审批哪条")

                }

            },


            panduandes() {

                var yes = false;

                for (var ss in this.xuanzhonglist) {

                    if (this.xuanzhonglist[ss].des == null || this.xuanzhonglist[ss].des == '') {

                        yes = true;

                    }

                }

                return yes;

            },

            newrefuse() {

                console.log(this.xuanzhonglist, 'this.xuanzhonglist')

                this.gouzaocanshu();

                //判断des有没有
                if (this.panduandes()) {

                    this.$msg.msge("请先填写意见")

                } else {

                    ss.orderCgService.approveFaillist(this.xuanzhonglist).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs(rd.msg);
                            this.$store.dispatch('searchTasktotal');
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msgs("审批失败！" + rd.msg);
                        }
                    })

                }

            },


            //构造参数
            gouzaocanshu() {

                for (var s in this.xuanzhonglist) {

                    this.xuanzhonglist[s].des = this.zy.des;

                }

            },

            //旧单驳回
            oldrefuse() {

                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.approveFail(this.zy).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs(rd.msg);
                        this.$store.dispatch('searchTasktotal');
                        this.$router.push("purchaselist");
                    } else {
                        this.$msg.msgs("审批失败！" + rd.msg);
                    }
                })

            },

            pass() {

                if (this.xuanzhonglist.length > 0) {

                    this.newpass();

                } else {

                    this.$msg.msge("请先选择审批哪条")

                }

            },

            newpass() {

                console.log(this.xuanzhonglist, 'this.xuanzhonglist')

                this.gouzaocanshu();

                ss.orderCgService.approveSuccesslist(this.xuanzhonglist).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs(rd.msg);
                        this.$store.dispatch('searchTasktotal');
                        this.$router.push("/personal/dealCenter");

                    } else {
                        this.$msg.msgs("审批失败！" + rd.msg);
                    }
                })

            },


            //旧单通过
            oldpass() {

                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.approveSuccess(this.zy).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs(rd.msg);
                        this.$store.dispatch('searchTasktotal');
                        this.$router.push("/personal/dealCenter");

                    } else {
                        this.$msg.msgs("审批失败！" + rd.msg);
                    }
                })

            },

            //供应商名字
            changeSup(v) {
                this.options2.forEach((item, index) => {
                    if (this.zy.suserCode == item.value) {
                        this.zy.suserName = item.label
                    }
                })
            },
            viewpress(r) {
                this.showhistory = true;
            },
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
                }
            },
            nextStep(i) {
                if (this.status == 1) {
                        this.status = 2;
                } else if (this.status == 2) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        	console.log(rd)
                        	this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        	console.log(rd)
                        	this.showOrhide = false;
                        })
                    }
                }
            }
        },

        created() {
			this.showzhezhao()
        }

    }
</script>

<style scoped>
    .passfollow {
        position: absolute;
        right: 0;
        bottom: 0.4rem;
        background-color: #2785e7;
        color: white;
    }

    .h1 {
        margin: 20px 0 0 31px;
    }

    .bbbb {
        background-color: white;
        padding-bottom: 30px;
    }

    .apprButton {
    	display: flex;
    	justify-content: center;
    	align-items: center;
    	width: 100%;
        padding: 0.3rem 0;
    }

    .cancel {
        width: 18%;
    }

    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }

    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }
</style>
<style>
    .dingdan4.h-formLine .el-form-item__content .el-input {
        width: 89%;
    }

    .dingdan4.h-formLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .dingdan4.h-formLine .newBox .el-form-item__label {
        width: 9.7%;
        text-align: right;
    }

    .dingdan4.h-formLine .el-form-item__content {
        width: 69%;
    }

    .dingdan4.h-formLine .newBox .el-form-item__content {
        width: 90.3%;
    }

    .dingdan4.h-formLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }
</style>
<style scoped lang="scss">
	.bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .steps {
            position: absolute;
            z-index: 1;

            &.step1 {
                top: 0;
                left: 0;
            }

            &.step2 {
                top: 0;
                left: 0;
            }
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .stepbtn1 {
            top: 5rem;
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
			z-index: 2;
        }
    }
</style>
